const translations = {
    // Hero Section
  "unlock_cosmic": "Your offering",
  "personalized_predictions": "Your offering directly supports the Goshala and spiritual missions. This simple action weaves good fortune into your life.",
  "hero_description": "Where ancient wisdom meets your modern life — explore Birth Charts, Numerology, Your Love Life, and Dasha Phal readings, all crafted by certified Jyotish experts to guide your path with clarity and purpose.",
  "get_my_report": "Get Full Report",
  "view_sample": "View Sample Report",

  // Features
  "detailed_reports": "2026 Personalized Life Report",
  // "horoscope_matching": "Kundli Matching",
  // "astrology_systems": "Birth Chart, Numerology, Dasha & More",
 
  // Modal
  "200_pages": "200+ Insightful Pages",
  "20_years_predictions": "20 Years of Future Predictions",
  "personalized_kundli": "Your Personalized Vedic Life Report",
  "most_detailed_india": "Complete & Comprehensive Guidance",
  "cosmic_blueprint_description": "Your life’s journey decoded through:",

  "predictions_doshas_remedies": "Detailed insights on Birth Chart, Dashas, Nakshatras, Numerology, Lal Kitab, Your Love Life, Career, Health Index, Sade Sati, Remedies & more.",
  "customized_for_you": "A divine report crafted exclusively for you by SriAstroVeda",
  "check_sample_kundli": "Explore Report",


    // Add to your translation files
    // Section Title & Description
    "authentic_vedic_astrology": "SriAstroVeda Astrology Services",
    "cosmic_destiny": "Your Destiny, Decoded &",
    "through_ancient_wisdom": "Guided by the Eternal Wisdom of Vedic Astrology",
    "two_section_description": "SriAstroVeda helps you make informed life choices through the ancient science of astrology — combining detailed Kundli analysis, Numerology, Dasha timelines, Your Love Life, and powerful Lal Kitab remedies. Discover your path with clarity and confidence.",

    // Features – focused on user benefits
    "personalized_birth_charts": "Understand Your True Self",
    "personalized_birth_charts_desc": "Get a complete analysis of your birth chart, ascendant, and planetary positions to uncover hidden strengths, weaknesses, and life patterns.",

    "remedial_gemstone_guidance": "Overcome Life's Obstacles",
    "remedial_gemstone_guidance_desc": "Receive effective remedies, gemstone suggestions, and Sade Sati analysis to neutralize planetary imbalances and attract positive outcomes.",

    "marriage_compatibility_analysis": "Find Harmonious Relationships",
    "marriage_compatibility_analysis_desc": "Use our advanced love and marriage compatibility tools to understand relationship dynamics and ensure long-term compatibility.",

    "career_life_predictions": "Plan Your Future with Confidence",
    "career_life_predictions_desc": "Get accurate predictions about career, health, finances, and yearly trends so you can plan ahead and make empowered decisions.",


    // CTA & Trust
    "start_your_journey": "Unlock Your Zodiac Path",
    "learn_more": "Explore Full Services",
    "rated_by_clients": "Rated 4.9/5 by 10,000+ Clients",
    "confidential_secure": "100% Confidential & Secure",

    "authentic_astrology_banner": "Authentic Astrology Services",

    "match_kundli": "Match Kundli",
    "match_kundli_desc": "Check marriage compatibility and kundli matching for you and your partner.",
    "match_now": "Match Now",

    "your_life_predictions": "Your Life Predictions",
    "life_predictions_desc": "Get a complete overview of your future based on your birth chart.",
    "view_predictions": "View Predictions",

    "ask_question_price": "Ask A Question",
    "ask_question_desc": "Get expert answers to any personal or urgent question.",
    "ask_now": "Ask Now",

    "career_guidance": "Career",
    "career_desc": "Discover the right career path and job opportunities based on your stars.",
    "explore_career": "Explore Career",

    "love_compatibility": "Love",
    "love_desc": "Understand your love life, relationship compatibility, and future romance.",
    "check_love_life": "Check Love Life",

    "2026_personalized_report": "2026 Personalized Report",
    "2026_report_desc": "Detailed yearly forecast tailored to your birth details.",
    "get_2026_report": "Get 2026 Report",

    "dasha_phal_analysis": "Dasha Phal Analysis",
    "dasha_analysis_desc": "Understand the impact of planetary periods (Dashas) on your life.",
    "analyze_now": "Analyze Now",

    "sade_sati_report": "Sade Sati Life Report",
    "sade_sati_desc": "Find out how Saturn's Sade Sati will affect you and get remedies.",
    "check_sade_sati": "Check Sade Sati",

        // Add to your translation files
    "free_daily_horoscope": "Every Sign, Every Secret – Discover What the Stars Say About You",
    "horoscope_categories": "",

    // Zodiac signs
    "aries": "Aries",
    "taurus": "Taurus", 
    "gemini": "Gemini",
    "cancer": "Cancer",
    "leo": "Leo",
    "virgo": "Virgo",
    "libra": "Libra",
    "scorpio": "Scorpio",
    "sagittarius": "Sagittarius",
    "capricorn": "Capricorn",
    "aquarius": "Aquarius",
    "pisces": "Pisces",

    // Date ranges
    "aries_dates": "Mar 21 - Apr 19",
    "taurus_dates": "Apr 20 - May 20",
    "gemini_dates": "May 21 - Jun 20",
    "cancer_dates": "Jun 21 - Jul 22",
    "leo_dates": "Jul 23 - Aug 22",
    "virgo_dates": "Aug 23 - Sep 22",
    "libra_dates": "Sep 23 - Oct 22",
    "scorpio_dates": "Oct 23 - Nov 21",
    "sagittarius_dates": "Nov 22 - Dec 21",
    "capricorn_dates": "Dec 22 - Jan 19",
    "aquarius_dates": "Jan 20 - Feb 18",
    "pisces_dates": "Feb 19 - Mar 20",

    // Modal content keys
    "today_horoscope": "Today's Horoscope",
    "basic_info": "Basic Information",
    "characteristics": "Characteristics",
    "lucky_elements": "Lucky Elements",
    "lucky_color": "Lucky Color",
    "lucky_number": "Lucky Number", 
    "element": "Element",
    "ruling_planet": "Ruling Planet",
    "get_detailed_reading": "Get Detailed Reading",
    "more_insights": "More Insights",
    "likes": "Likes",
    "dislikes": "Dislikes",
    "food": "Food",
    "travel_style": "Travel Style",
    "movie_match": "Movie Match",
    "song_vibe": "Song Vibe",
    "celebs": "Celebrities",

    // Aries content
    "aries_horoscope": "Today brings fiery energy and new opportunities. Your leadership skills will shine, making it a perfect day to start new projects or take charge of situations.",
    "aries_traits": "Fearless, competitive, full of energy and initiative. Always first to take action.",
    "aries_likes": "Winning, leadership, excitement, challenges.",
    "aries_dislikes": "Laziness, delays, indecision.",
    "aries_food": "Spicy food, grilled meats, protein-rich meals.",
    "aries_travel_style": "Adventure sports, solo trekking, road trips.",
    "aries_movie_match": "Mad Max: Fury Road",
    "aries_song_vibe": "Eye of the Tiger",
    "aries_celebs": "Lady Gaga, Ajay Devgn, Robert Downey Jr.",
    "aries_color": "Red",
    "aries_number": "9",
    "aries_element": "Fire",
    "aries_planet": "Mars",

    "taurus_horoscope": "A day for indulgence and comfort. Focus on stability and enjoy the finer things in life. Your patience will be rewarded with lasting results.",
    "taurus_traits": "Calm, reliable, sensual, loyal. Loves comfort and luxury.",
    "taurus_likes": "Nature, music, good food, fine things.",
    "taurus_dislikes": "Sudden change, being rushed, instability.",
    "taurus_food": "Rich meals, desserts, gourmet cheese, chocolates.",
    "taurus_travel_style": "Nature retreats, vineyards, luxury resorts.",
    "taurus_movie_match": "The Hundred-Foot Journey",
    "taurus_song_vibe": "All of Me",
    "taurus_celebs": "Gigi Hadid, Varun Dhawan, Adele",
    "taurus_color": "Green & Pink",
    "taurus_number": "6",
    "taurus_element": "Earth",
    "taurus_planet": "Venus",

    "gemini_horoscope": "Communication is key today. Your wit and adaptability will open new doors. Perfect time for networking and sharing ideas.",
    "gemini_traits": "Social, witty, adaptable, fast thinkers, multi-taskers.",
    "gemini_likes": "Talking, writing, tech, new experiences.",
    "gemini_dislikes": "Repetition, boredom, silence.",
    "gemini_food": "Finger food, street snacks, quirky dishes.",
    "gemini_travel_style": "Short spontaneous trips, city exploration.",
    "gemini_movie_match": "The Social Network",
    "gemini_song_vibe": "Levitating",
    "gemini_celebs": "Angelina Jolie, Karan Johar, Kanye West",
    "gemini_color": "Yellow",
    "gemini_number": "5",
    "gemini_element": "Air",
    "gemini_planet": "Mercury",

    "cancer_horoscope": "Trust your intuition today. Family and home matters take priority. Your nurturing nature will bring comfort to those around you.",
    "cancer_traits": "Deeply emotional, nurturing, intuitive, family-oriented.",
    "cancer_likes": "Home, comfort food, memories, close friends.",
    "cancer_dislikes": "Harshness, abandonment, change.",
    "cancer_food": "Homely meals, rice dishes, desserts.",
    "cancer_travel_style": "Beach houses, ancestral places, spiritual retreats.",
    "cancer_movie_match": "The Notebook",
    "cancer_song_vibe": "Photograph",
    "cancer_celebs": "Selena Gomez, Priyanka Chopra, Tom Hanks",
    "cancer_color": "White & Silver",
    "cancer_number": "2",
    "cancer_element": "Water",
    "cancer_planet": "Moon",

    "leo_horoscope": "Your natural charisma shines bright today. Take center stage and let your creativity flow. Recognition and praise are coming your way.",
    "leo_traits": "Bold, dramatic, warm-hearted, born leader. Craves attention.",
    "leo_likes": "Glamour, stage, celebrations, leadership.",
    "leo_dislikes": "Being ignored, dullness, criticism.",
    "leo_food": "Grilled foods, rich desserts, exotic dishes.",
    "leo_travel_style": "Luxury cruises, cultural parades, spotlight destinations.",
    "leo_movie_match": "The Great Gatsby",
    "leo_song_vibe": "Uptown Funk",
    "leo_celebs": "Jennifer Lopez, Saif Ali Khan, Barack Obama",
    "leo_color": "Gold & Orange",
    "leo_number": "1",
    "leo_element": "Fire",
    "leo_planet": "Sun",

    "virgo_horoscope": "Attention to detail pays off today. Your analytical skills help solve complex problems. Focus on health and organization for best results.",
    "virgo_traits": "Perfectionist, practical, intelligent, health-conscious.",
    "virgo_likes": "Cleanliness, plans, helping, learning.",
    "virgo_dislikes": "Chaos, inefficiency, emotional outbursts.",
    "virgo_food": "Healthy bowls, clean eating, soups, salads.",
    "virgo_travel_style": "Wellness resorts, eco stays, heritage sites.",
    "virgo_movie_match": "The Imitation Game",
    "virgo_song_vibe": "Lovely",
    "virgo_celebs": "Keanu Reeves, Kareena Kapoor, Zendaya",
    "virgo_color": "White & Earth Tones",
    "virgo_number": "6",
    "virgo_element": "Earth",
    "virgo_planet": "Mercury",

    "libra_horoscope": "Harmony and balance guide your day. Relationships flourish when you focus on fairness and beauty. Artistic pursuits bring joy.",
    "libra_traits": "Graceful, fair, romantic, peace-loving, aesthetic.",
    "libra_likes": "Art, fashion, romance, conversation.",
    "libra_dislikes": "Rudeness, arguments, imbalance.",
    "libra_food": "Pastries, wine, cheese, light pastas.",
    "libra_travel_style": "Paris, Venice, romantic or fashion destinations.",
    "libra_movie_match": "La La Land",
    "libra_song_vibe": "Just the Way You Are",
    "libra_celebs": "Kim Kardashian, Ranbir Kapoor, Hugh Jackman",
    "libra_color": "Sky Blue & Rose Pink",
    "libra_number": "7",
    "libra_element": "Air",
    "libra_planet": "Venus",

    "scorpio_horoscope": "Deep transformation is in the air. Trust your instincts and embrace change. Your intensity and passion lead to breakthrough moments.",
    "scorpio_traits": "Mysterious, intense, loyal, emotionally deep.",
    "scorpio_likes": "Secrets, transformation, passion.",
    "scorpio_dislikes": "Dishonesty, shallow people, betrayal.",
    "scorpio_food": "Spicy, bold flavors, dark chocolate, mystery meals.",
    "scorpio_travel_style": "Hidden gems, caves, secret beaches.",
    "scorpio_movie_match": "Gone Girl",
    "scorpio_song_vibe": "Take Me to Church",
    "scorpio_celebs": "Ryan Gosling, Shah Rukh Khan, Katy Perry",
    "scorpio_color": "Black & Deep Red",
    "scorpio_number": "8",
    "scorpio_element": "Water",
    "scorpio_planet": "Mars & Pluto",

    "sagittarius_horoscope": "Adventure calls your name today. Expand your horizons through learning or travel. Your optimism inspires others to dream bigger.",
    "sagittarius_traits": "Free-spirited, funny, philosophical, optimistic.",
    "sagittarius_likes": "Travel, adventure, truth, deep conversations.",
    "sagittarius_dislikes": "Rules, clinginess, routine.",
    "sagittarius_food": "Street food, BBQ, international cuisines.",
    "sagittarius_travel_style": "Backpacking, offbeat adventures, solo trips.",
    "sagittarius_movie_match": "Into the Wild",
    "sagittarius_song_vibe": "Adventure of a Lifetime",
    "sagittarius_celebs": "Taylor Swift, Dharmendra, Brad Pitt",
    "sagittarius_color": "Purple & Turquoise",
    "sagittarius_number": "9",
    "sagittarius_element": "Fire",
    "sagittarius_planet": "Jupiter",

    "capricorn_horoscope": "Hard work and discipline bring success today. Your methodical approach opens doors to long-term achievements. Stay focused on your goals.",
    "capricorn_traits": "Ambitious, mature, disciplined, timeless.",
    "capricorn_likes": "Success, structure, loyalty, traditions.",
    "capricorn_dislikes": "Laziness, dishonesty, shortcuts.",
    "capricorn_food": "Traditional meals, soups, breads, slow-cooked food.",
    "capricorn_travel_style": "Hills, historical cities, business-leisure trips.",
    "capricorn_movie_match": "The Pursuit of Happyness",
    "capricorn_song_vibe": "Hall of Fame",
    "capricorn_celebs": "Deepika Padukone, Hrithik Roshan, Michelle Obama",
    "capricorn_color": "Navy & Brown",
    "capricorn_number": "10",
    "capricorn_element": "Earth",
    "capricorn_planet": "Saturn",

    "aquarius_horoscope": "Innovation and humanitarian efforts take center stage. Your unique perspective brings fresh solutions to old problems. Think outside the box.",
    "aquarius_traits": "Visionary, independent, unconventional, humanitarian.",
    "aquarius_likes": "Innovation, social causes, ideas, community.",
    "aquarius_dislikes": "Restrictions, stereotypes, routine.",
    "aquarius_food": "Vegan/plant-based, fusion food, smoothies.",
    "aquarius_travel_style": "Futuristic cities, volunteer tourism, road trips with a cause.",
    "aquarius_movie_match": "The Matrix",
    "aquarius_song_vibe": "Radioactive",
    "aquarius_celebs": "Oprah Winfrey, Preity Zinta, Harry Styles",
    "aquarius_color": "Electric Blue & Aqua",
    "aquarius_number": "11",
    "aquarius_element": "Air",
    "aquarius_planet": "Uranus & Saturn",

    "pisces_horoscope": "Let your imagination flow today. Dreams and intuition guide you to beautiful discoveries. Your compassionate nature touches many hearts.",
    "pisces_traits": "Empathetic, dreamy, artistic, intuitive.",
    "pisces_likes": "Art, love stories, music, dreams.",
    "pisces_dislikes": "Harsh realities, loud crowds, conflict.",
    "pisces_food": "Seafood, pasta, comfort food, ice cream.",
    "pisces_travel_style": "Islands, retreats, riverside escapes.",
    "pisces_movie_match": "Life of Pi",
    "pisces_song_vibe": "Someone Like You",
    "pisces_celebs": "Rihanna, Alia Bhatt, Justin Bieber",
    "pisces_color": "Lavender & Sea Green",
    "pisces_number": "12",
    "pisces_element": "Water",
    "pisces_planet": "Neptune & Jupiter",

    "review_title": "Energy Exchange: Their Words, Our Gratitude",

    "why_choose": "Why Choose SriAstroVeda",
    
    "unlimited_kundlis_question": "Can I request multiple Kundlis?",
    "unlimited_kundlis_answer": "Yes! You can submit details for as many individuals as you like. Each request will be carefully prepared and delivered as a personalized PDF report.",

    "kundli_reports_question": "What’s included in the Kundli reports?",
    "kundli_reports_answer": "Each report is a **professionally prepared PDF** covering Birth Chart, Ascendant Analysis, Dasha, Gochar, Nakshatra, Numerology, Love & Career Guidance, Health Index, Lal Kitab Remedies, and more.",

    "saving_notes_question": "Can I get session notes or remedies added?",
    "saving_notes_answer": "Absolutely. If you want specific remedies, follow-up notes, or additional observations included, simply mention them during your request.",

    "devices_question": "How do I receive the report?",
    "devices_answer": "You’ll receive the report **within 24 hours** in PDF format via **WhatsApp, Email, or SMS**—whichever method you prefer.",

    "data_safety_question": "Is my personal data safe?",
    "data_safety_answer": "Yes. All user data is kept **completely confidential** and is never shared. Your privacy and trust are our highest priorities.",

    "advertising_question": "Is the report free from ads?",
    "advertising_answer": "**100% ad-free.** Our reports are designed to deliver pure, focused astrological insights without any promotional distractions.",

    "client_management_question": "Can I order reports for my clients?",
    "client_management_answer": "Yes! Whether you're an astrologer, consultant, or wellness coach, you can order personalized reports for your clients. Bulk and recurring orders are supported.",

    "customize_charts_question": "Can I choose chart style or layout?",
    "customize_charts_answer": "Yes. We offer **North, South, and East Indian chart formats**. You can also request font size or color preferences if needed.",

    "discounts_question": "Are there any discounts available?",
    "discounts_answer": "Yes. We provide **seasonal discounts**, **combo offers**, and special rates for astrologers and regular clients. Stay connected via WhatsApp for updates.",

    "affiliate_question": "Can I earn by referring others?",
    "affiliate_answer": "Yes! Join the **SriAstroVeda Affiliate Program** and earn commissions by referring friends, clients, or your audience.",

    "languages_question": "Are reports available in regional languages?",
    "languages_answer": "Yes. We offer reports in **Hindi, English, Telugu, Kannada, Tamil, Marathi and Bengali**, and other regional languages on request.",

    "delivery_time_question": "How soon will I receive my report?",
    "delivery_time_answer": "You’ll receive your full report **within 24 hours** after submitting your details. Delivery is available via WhatsApp, Email, or SMS.",

    "services_question": "What astrology services are included?",
    "services_answer": "Our reports include: **Birth Chart, Kundli Matching, Ascendant & Dasha Analysis, Gochar, Nakshatra, Numerology, Career & Love Guidance, Yearly & Daily Predictions, Health Index, Lal Kitab Remedies, Sade Sati Reports, Dosha Analysis, Gemstone Suggestions**, and much more.",

    "unmute_first_card": "Unmute First Card",
    "mute_first_card": "Mute First Card"

};

export default translations;
